module.exports = __webpack_public_path__ + "static/img/sp_2.91bca97.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/sports/sp_2.png
// module id = 841
// module chunks = 1